// extracted by mini-css-extract-plugin
export default {"operationArea":"List_operationArea__4ckJN","tabs":"List_tabs__cG3ti","detail":"List_detail__X7xnx","wrapper":"List_wrapper__66R2-","col":"List_col__vyXwR"};